import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { trackBookingClick } from '../lib/tracking';

export default function WhyChoose() {
  const { t } = useLanguage();
  const benefits = t.whyChoose.benefits;

  return (
    <section className="py-24 px-6 md:px-12 lg:px-20 bg-[#DADed8] animate-on-scroll">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="eyebrow eyebrow-center mb-5">{t.whyChoose.eyebrow}</span>
          <h2 className="section-heading text-3xl md:text-5xl font-light mt-5 mb-5 text-[#2c3424]">
            {t.whyChoose.titleLine1}
            <span className="block font-semibold">{t.whyChoose.titleLine2}</span>
          </h2>
          <p className="text-lg text-[#1a1a1a]/80 max-w-2xl mx-auto leading-relaxed">
            {t.whyChoose.intro}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className={`premium-card p-7 ${index === benefits.length - 1 ? 'md:col-span-2' : ''}`}
            >
              <div className="flex items-start gap-4">
                <span className="card-index shrink-0" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-2 text-[#2c3424] leading-snug">
                    {benefit.title}
                  </h3>
                  <p className="text-base text-[#1a1a1a]/75 leading-relaxed">{benefit.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="rule-diamond my-12" aria-hidden="true"><span /></div>

        <p className="text-lg md:text-xl text-center font-light text-[#2c3424] max-w-3xl mx-auto leading-relaxed">
          {t.whyChoose.closingLead}<span className="font-semibold">{t.whyChoose.closingStrong}</span>
        </p>

        <div className="text-center mt-12">
          <div className="button-wrapper inline-block">
            <a
              href="https://medispahr.wixforms.com/f/7479898417246766083"
              target="_blank"
              rel="noopener noreferrer"
              data-cta="book_now"
              data-cta-location="why_choose"
              onClick={() => trackBookingClick('why_choose')}
              className="cta-premium guten-button inline-block px-10 py-4 bg-[#768064] text-white text-base font-semibold rounded-full transition-all duration-300 hover:bg-[#5d6950]">
              <span>{t.common.bookConsultation}</span>
            </a>
          </div>
        </div>
      </div>
    </section>);
}
